export default __webpack_public_path__ + "static/media/burger-new.dd85d54d.svg";